<div class="middle-box text-center loginscreen animated fadeInDown">
  <div>
    <div *ngIf="errorMessage">
      <div class="widget style1 red-bg">
        <div class="row">
          <div class="col-xs-4">
            <i class="fa fa-exclamation-triangle fa-5x"></i>
          </div>
          <div class="col-xs-8 text-right">
            <h2 class="font-bold">{{ errorMessage }}</h2>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!errorMessage">
      <div class="widget style1 yellow-bg">
        <div class="row">
          <div class="col-xs-4">
            <i class="fa fa-cog fa-5x fa-spin"></i>
          </div>
          <div class="col-xs-8 text-right">
            <span>Check token</span>
            <h2 class="font-bold">Wait</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
